// Inspired by: https://github.com/excid3/tailwindcss-stimulus-components/blob/master/src/popover.js

import { Controller } from "@hotwired/stimulus";
import { createPopper } from "@popperjs/core";

export default class UIPopover extends Controller {
  static values = {
    dismissAfter: Number,
  };
  static targets = ["content", "wrapper", "trigger"];

  connect() {
    const side = this.contentTarget.dataset.side || "bottom";
    const align = this.contentTarget.dataset.align || "center";

    // Convert align to Popper.js placement format
    let placement = side;
    if (align === "start") {
      placement = `${side}-start`;
    } else if (align === "end") {
      placement = `${side}-end`;
    }

    this.popperInstance = createPopper(this.triggerTarget, this.contentTarget, {
      placement: placement,
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 8],
          },
        },
      ],
    });

    // Add click outside listener
    this.clickOutsideListener = this.clickOutside.bind(this);

    // Add custom event listener for position updates
    this.element.addEventListener("popover:update", this.updatePosition.bind(this));
  }

  updatePosition() {
    if (this.popperInstance) {
      this.popperInstance.update();
    }
  }

  disconnect() {
    // Clean up event listener
    if (this.clickOutsideListener) {
      document.removeEventListener("click", this.clickOutsideListener);
    }
  }

  // Show the popover
  show() {
    this.contentTarget.classList.remove("hidden");
    this.contentTarget.dataset.state = "open";
    // Add click outside listener when popover opens
    setTimeout(() => {
      document.addEventListener("click", this.clickOutsideListener);
    }, 0);
  }

  // Hide the popover
  hide() {
    this.contentTarget.classList.add("hidden");
    this.contentTarget.dataset.state = "closed";
    // Remove click outside listener when popover closes
    document.removeEventListener("click", this.clickOutsideListener);
  }

  clickOutside(event) {
    // Check if the click is outside the popover content and trigger
    if (!this.element.contains(event.target)) {
      this.hide();
    }
  }

  // Toggle the popover on demand
  toggle(event) {
    this.popperInstance.update();
    if (this.contentTarget.classList.contains("hidden")) {
      this.show();

      if (this.hasDismissAfterValue) {
        setTimeout(() => {
          this.hide();
        }, this.dismissAfterValue);
      }
    } else {
      this.hide();
    }
  }
}
